// src/Login.js
import React, { useState } from 'react';
import { Auth } from 'aws-amplify';
import { useNavigate } from 'react-router-dom';
import { setAuthUser } from './authUserStore';
import './Login.css';

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const user = await Auth.signIn(username, password);
      console.log('Kirjautuminen onnistui:', user);
      
      if (user.challengeName === 'NEW_PASSWORD_REQUIRED') {
        setAuthUser(user);
        navigate('/new-password');
      } else {
        navigate('/dashboard');
      }
    } catch (error) {
      console.error('Kirjautumisvirhe:', error);
      setErrorMessage(error.message || 'Kirjautumisessa tapahtui virhe');
    }
  };

  return (
    <div className="login-container">
      <img src="/stcloud.png" alt="Logo" className="logo" />
      
      <h2>Kirjaudu sisään</h2>
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="username">Käyttäjänimi</label>
          <input
            type="text"
            id="username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            placeholder="Anna käyttäjänimesi"
            required
          />
        </div>
        <div className="form-group">
          <label htmlFor="password">Salasana</label>
          <input
            type="password"
            id="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Anna salasanasi"
            required
          />
        </div>
        {errorMessage && <p className="error">{errorMessage}</p>}
        <button type="submit">Kirjaudu</button>
      </form>
    </div>
  );
};

export default Login;
